export const tr = {
    'empty-selected-screens': 'Hiçbir ekran seçilmedi',
    'need-to-select-city': 'Şehir seçilmelidir'
};
